import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { RELEASE_STATUS_TAG_TYPE, PRODUCT_TAG_TYPE } from "components/pages/whats-new/utils";
import classnames from "classnames";
import { StyledWhatsNewItemTag } from "./tag.scss";
import { ID_TO_OPTIONS_NAMES_AND_COLORS, WHATS_NEW_ITEM_TAG_TEXT_COLOR } from "../../consts";
import { getFilterIcon } from "components/pages/whats-new/utils";
const WhatsNewItemTag = (props)=>{
    var _ID_TO_OPTIONS_NAMES_AND_COLORS_tagType_data_tagId, _ID_TO_OPTIONS_NAMES_AND_COLORS_tagType, _ID_TO_OPTIONS_NAMES_AND_COLORS_tagType_data_tagId1, _ID_TO_OPTIONS_NAMES_AND_COLORS_tagType1, _ID_TO_OPTIONS_NAMES_AND_COLORS_tagType2;
    const { tagId, tagType } = props;
    const tagName = (_ID_TO_OPTIONS_NAMES_AND_COLORS_tagType = ID_TO_OPTIONS_NAMES_AND_COLORS[tagType]) === null || _ID_TO_OPTIONS_NAMES_AND_COLORS_tagType === void 0 ? void 0 : (_ID_TO_OPTIONS_NAMES_AND_COLORS_tagType_data_tagId = _ID_TO_OPTIONS_NAMES_AND_COLORS_tagType.data[tagId]) === null || _ID_TO_OPTIONS_NAMES_AND_COLORS_tagType_data_tagId === void 0 ? void 0 : _ID_TO_OPTIONS_NAMES_AND_COLORS_tagType_data_tagId.name;
    const tagBackgroundColor = tagType === PRODUCT_TAG_TYPE ? (_ID_TO_OPTIONS_NAMES_AND_COLORS_tagType1 = ID_TO_OPTIONS_NAMES_AND_COLORS[tagType]) === null || _ID_TO_OPTIONS_NAMES_AND_COLORS_tagType1 === void 0 ? void 0 : (_ID_TO_OPTIONS_NAMES_AND_COLORS_tagType_data_tagId1 = _ID_TO_OPTIONS_NAMES_AND_COLORS_tagType1.data[tagId]) === null || _ID_TO_OPTIONS_NAMES_AND_COLORS_tagType_data_tagId1 === void 0 ? void 0 : _ID_TO_OPTIONS_NAMES_AND_COLORS_tagType_data_tagId1.backgroundColor : (_ID_TO_OPTIONS_NAMES_AND_COLORS_tagType2 = ID_TO_OPTIONS_NAMES_AND_COLORS[tagType]) === null || _ID_TO_OPTIONS_NAMES_AND_COLORS_tagType2 === void 0 ? void 0 : _ID_TO_OPTIONS_NAMES_AND_COLORS_tagType2.backgroundColor;
    return /*#__PURE__*/ _jsxs(StyledWhatsNewItemTag, {
        className: classnames("tag", {
            "release-status": tagType === RELEASE_STATUS_TAG_TYPE
        }),
        style: {
            color: WHATS_NEW_ITEM_TAG_TEXT_COLOR,
            backgroundColor: tagBackgroundColor
        },
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "tag-dot"
            }),
            getFilterIcon(tagName),
            tagName
        ]
    });
};
export default WhatsNewItemTag;
